import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import { withRouter, Link } from 'react-router-dom';
import XLSX from 'xlsx';
import {
  Col,
  Container,
  Row,
  Alert,
} from 'reactstrap';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import { getInfoData, addInfoData, updateInfoData, deleteInfoData } from '../../store/priceList/actions';

import PageLoader from '../../components/Loaders/pageLoader';
// Pages Components
// import BoxSizesComp from "./Data/boxSizes"
// import FedexEmsComp from "./Data/fedexEms"
import LanguagesComp from "./Info/languages"
import CountriesComp from "./Info/countries"
import CategoriesComp from "./Info/categories"

class PriceInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  componentDidMount() {
    const { onGetInfoData } = this.props;
    onGetInfoData();
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }
  /**
   * Get screen height
   */
  getScreenHeight = () => {
    if (document.getElementById('card-section') != null) {
      let screenHeight = document.getElementById('card-section').offsetHeight;
      const nodeList = document.querySelectorAll('.react-bootstrap-table');
      for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].setAttribute('style', 'height: calc(' + screenHeight + 'px - 100px); overflow: auto;');
      }
    }
  };

  render() {
    const { loading, profileData } = this.props;
    console.log(this.props)
    return (
      <React.Fragment>
        <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>
        <div className='page-content'>
          <MetaTags>
            <title>Price List</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('priceLstAccessView') ? (
              <>
              <Breadcrumbs title='Admin' breadcrumbItem='Price List Data' />
              <Row id='card-section'>
                <Col lg='4'>
                  <CountriesComp props={this.props} />
                </Col>
                <Col lg='2'>
                  <LanguagesComp props={this.props} />
                </Col>
                <Col lg='6'>
                  <CategoriesComp props={this.props} />
                </Col>
              </Row>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PriceInfo.propTypes = {
  languages: PropTypes.array,
  countries: PropTypes.array,
  categories: PropTypes.array,
  sub_categories: PropTypes.array,
  users: PropTypes.array
};

const mapStateToProps = ({ priceList }) => ({
  languages: priceList.languages,
  countries: priceList.countries,
  categories: priceList.categories,
  sub_categories: priceList.sub_categories,
  users: priceList.users,
  loading: priceList.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetInfoData: () => dispatch(getInfoData()),
  onAddInfoData: (data) => dispatch(addInfoData(data)),
  onEditInfoData: (data) => dispatch(updateInfoData(data)),
  onDeleteInfoData: (data) => dispatch(deleteInfoData(data)),
  // onEditResponsible: (data) => dispatch(updateRespRegion(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PriceInfo));